import { render, staticRenderFns } from "./BarraCheckBox.vue?vue&type=template&id=c35b4b8e&scoped=true&"
import script from "./BarraCheckBox.vue?vue&type=script&lang=js&"
export * from "./BarraCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./BarraCheckBox.vue?vue&type=style&index=0&id=c35b4b8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35b4b8e",
  null
  
)

export default component.exports